"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapupTracker = void 0;
const tracker_1 = require("../tracker");
class WrapupTracker extends tracker_1.Tracker {
    constructor(config, wrapupSendInfo) {
        super(config);
        this.id = 'wrapup';
        this.sendInfo = (data) => {
            const { actionCode, errorMessage = '', obj: { navigationId, operation } = {}, operationError = false, sessionId } = data;
            if (sessionId && actionCode && navigationId && operation) {
                const obj = {
                    navigationId,
                    operation,
                };
                this.wrapupSendInfo(sessionId, actionCode, operationError, errorMessage, obj);
            }
        };
        this.wrapupSendInfo = wrapupSendInfo;
    }
}
exports.WrapupTracker = WrapupTracker;
//# sourceMappingURL=wrapupTracker.js.map